import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Tooltip from "@material-ui/core/Tooltip";
import { HelpTwoTone } from "@material-ui/icons";
import React from "react";

const GridField = (props) => {
  const {label, children, required, help} = props

  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        <Grid
          item
          sx={{
            justifyContent: "flex-end",
            textAlign: {
              sm: "right",
            },
            flexBasis: {
              xs: "100%",
              sm: 200,
            },
          }}
        >
          <Box
            sx={{
              pt: 1,
              pr: 2,
            }}
          >
            {label ? (
              <InputLabel required={required}>
                  {label === 'Цена' ?
                      (<><span>{label}</span><span style={{color: 'red'}}> *</span></>)
                      : label}
                {help ? (
                  <Tooltip title={help}>
                    <HelpTwoTone
                      color={"info"}
                      fontSize={"small"}
                      sx={{ verticalAlign: "top", marginLeft: 1 }}
                    />
                  </Tooltip>
                ) : null}
              </InputLabel>
            ) : null}
          </Box>
        </Grid>
        <Grid item xs>
          {children}
        </Grid>
      </Grid>
    </Grid>
  )
  
}

export default GridField